import { RouteObject } from 'react-router-dom';
import { ShowHQPlus } from '../components/common/ShowHQPlus';
import React from 'react';
import { ShowAboutUs } from '../components/common/ShowAboutUs';

import { ShowHQPlusLaunch } from '../components/common/ShowHQPlusLaunch';
import { SizzleVideoPage } from '../components/SizzleVideoPage';

// Lazy Load components
const LandingPage = React.lazy(() => import('../components/LandingPage/LandingPage'));
const Courses = React.lazy(() => import('../components/Courses/Courses'));
const SingleCourseView = React.lazy(
  () => import('../components/Courses/SingleCourseView/SingleCourseView')
);
const AboutUs = React.lazy(() => import('../components/AboutUs/AboutUs'));
const Accordion = React.lazy(() => import('../components/FAQ/Accordion'));
const PrivacyPolicy = React.lazy(() => import('../components/PrivacyPolicy/PrivacyPolicy'));
const TermsAndConditions = React.lazy(
  () => import('../components/TermsAndConditions/TermsAndConditions')
);
const WorkshopPage = React.lazy(() => import('../components/Workshops/WorkshopPage'));
const ContactUsFormMain = React.lazy(
  () => import('../components/Workshops/ContactUsForm/ContactUsFormMain')
);

const routes: RouteObject[] = [
  {
    path: 'plus',
    element: <ShowHQPlus />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: 'courses',
        children: [
          {
            index: true,
            element: <Courses />,
          },
          {
            path: ':id',
            index: true,
            element: <SingleCourseView />,
          },
        ],
      },
      {
        path: 'about',
        element: <ShowHQPlusLaunch />,
        children: [
          {
            children: [
              {
                index: true,
                element: <SizzleVideoPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'about-us',
    element: <ShowAboutUs />,
    children: [
      {
        index: true,
        element: <AboutUs />,
      },
    ],
  },
  {
    path: 'faq',
    index: true,
    element: <Accordion />,
  },
  {
    path: 'privacy-policy',
    index: true,
    element: <PrivacyPolicy />,
  },
  {
    path: 'terms-and-conditions',
    index: true,
    element: <TermsAndConditions />,
  },
  {
    path: 'live',
    index: true,
    element: <WorkshopPage />,
  },
  {
    path: 'form',
    index: true,
    element: <ContactUsFormMain />,
  },
];

export default routes;
